



























import { defineComponent, computed, ref } from "@vue/composition-api";

import store from "@/store";
import { useLoadingEvent } from "@/hooks/useLoadingEvent.hook";
import Loading from "vue-loading-overlay";
import LoadingOverlay from "@/shared/components/LoadingOverlay";
import MeterReadingLoginForm from "./MeterReadingLoginForm.vue";
import MeterReadings from "./MeterReadings.vue";

export default defineComponent({
  name: "MeterReadingComponent",
  components: {
    Loading,
    LoadingOverlay,
    MeterReadingLoginForm,
    MeterReadings,
  },
  props: {
    config: {},
  },
  setup(props: any, ctx: any) {
    const { componentIsLoading } = useLoadingEvent({
      root: ctx.root,
      componentID: "MeterReadingComponent",
    });
    // Get nescessary functions and values from the store
    const {
      getUserHasValidLoginCombination,
      setHasValidCombination,
      setMaloID,
      setMeterReadingID,
    } = store.dispatch;

    // Initialization logic with async setters and functions
    const initializeComponent = async () => {
      // If no maloID or meterReadingID are set yet, use the ones in params
      // if none are present, the login will be rendered through the computed we use from the store
      if (!maloID.value || !meterReadingID.value) {
        await setHasValidCombination(false);
        !maloID.value && (await setMaloID(maloIDParam));
        !meterReadingID.value && (await setMeterReadingID(meterReadingIDParam));
      }

      // @ts-ignore
      await getUserHasValidLoginCombination();
      isFetchingCustomerData.value = false;
    };

    // Get URL params
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const meterReadingIDParam = searchParams.get("zaehlernummer") ?? undefined;
    const maloIDParam = searchParams.get("maloid") ?? undefined;
    // Set nescessary states
    const isFetchingCustomerData = ref(true);
    // Get values from store
    const maloID = computed(() => store.getters.maloID);
    const meterReadingID = computed(() => store.getters.meterReadingID);
    // Returns if maloID and meterReadingID and also hasValidLogin are set in store
    const hasValidLoginData = computed(() => store.getters.hasValidLoginData);

    initializeComponent();

    const showLoadingOverlay = computed(
      () => componentIsLoading.value || isFetchingCustomerData.value
    );

    return {
      showLoadingOverlay,
      hasValidLoginData,
      maloIDParam,
      meterReadingIDParam,
    };
  },
});
